export default "__VITE_ASSET__CDRciHs6__"